import { Check, LockKeyhole } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';
import type { AppRoute } from './page-registry';

export function PermissionMatrixPage({ route }: { route: Omit<AppRoute, 'element'> }) {
  const { permissions, memberships } = useAuth();
  const Icon = route.icon;

  return (
    <section className="page-surface permission-page">
      <header className="page-header">
        <div className="page-title-row">
          <span className="page-icon">
            <Icon size={20} />
          </span>
          <div>
            <p className="eyebrow">Live session</p>
            <h1>{route.title}</h1>
          </div>
        </div>
      </header>

      <div className="permission-layout">
        <article className="work-card">
          <div className="card-heading">
            <LockKeyhole size={18} />
            <h2>Roles</h2>
          </div>
          <div className="role-list">
            {memberships.length > 0 ? (
              memberships.map((membership) => (
                <span key={`${membership.roleId}-${membership.workspaceId || membership.organizationId}`}>
                  {membership.roleName}
                </span>
              ))
            ) : (
              <span>No role metadata loaded</span>
            )}
          </div>
        </article>

        <article className="work-card permission-card">
          <div className="card-heading">
            <Check size={18} />
            <h2>Permissions</h2>
          </div>
          <div className="permission-list">
            {permissions.length > 0 ? (
              permissions.map((permission) => <span key={permission}>{permission}</span>)
            ) : (
              <p>No permissions returned by `/v2/iam/me`.</p>
            )}
          </div>
        </article>
      </div>
    </section>
  );
}
